import "./landing-page-header-link.component.scss";

export default {
    template: require('./landing-page-header-link.component.html'),
    transclude: true,
    bindings: {
        path: "@?vuiPath",
        altPath: "@?vuiAltPath",
        type: "@?vuiType"
    },
    controller: function ($location) {
        'ngInject';

        this.location = $location
    }
};
